import { Component, Injector, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestErrorManager } from 'src/app/submodules/angular-common/errors/rest-error-manager';
import { SecurityDataService } from 'src/app/submodules/angular-common/security-data.service';
import { FormSettings } from '../../../forms/form-settings';
import { PageFormComponent } from '../../../forms/page-form.component';
import { NotificationDataService } from '../../../notification-data.service';
import { VerifyContactService } from './verify-contact.service';

@Component({
  selector: 'app-verify-contact',
  templateUrl: './verify-contact.component.html',
  styleUrls: ['./verify-contact.component.scss'],
  providers: [VerifyContactService]
})
export class VerifyContactComponent extends PageFormComponent {

  @Input() public contactType: 'email'|'mobile';

  multipleOtpRequestsPreventionTimer;
  preventMultipleOtpRequests;
  
  constructor(protected _injector: Injector) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        otp: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }
  
  /** @override */
  protected async _submitHook() {
    if(this.contactType=="email")
      await this._injector.get(VerifyContactService).confirmEmailAddress(this.currentValues.otp as string)
    else if(this.contactType=="mobile")
      await this._injector.get(VerifyContactService).confirmMobileNumber(this.currentValues.otp as string)
    else throw new Error("contactType not defined")
  }

  public async requireNewOtp(){
    if (!this.preventMultipleOtpRequests) {
      this.preventMultipleOtpRequests = true;
      try {
        if(this.contactType=="email")
          await this._injector.get(VerifyContactService).requireEmailConfirmationOtp()
        else if(this.contactType=="mobile")
          await this._injector.get(VerifyContactService).requireMobileNumberConfirmationOtp()
        else throw new Error("contactType not defined")
        this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("VERIFY_CONTACT.OTP_SENT"));
      } catch (error) {
        this._injector.get(RestErrorManager).manageError(error,{callback:
          () => {
            this._injector.get(SecurityDataService).logout();
            this._injector.get(Router).navigateByUrl('/')
          }
        });
      }
      this.multipleOtpRequestsPreventionTimer = setTimeout(async () => {
        this.preventMultipleOtpRequests = false;
      }, 10000);
    }
  }
}
